// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"2b6edd7f","233":"46cdf906","451":"a22e2c7a","453":"4bcdc434","469":"5352c25f","551":"12264ccd","904":"4578f870"}[chunkId] + ".chunk.js";
};